'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidNotifications = function IoAndroidNotifications(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 36.3c-1.8 0-3.3-1.5-3.3-3.3h6.5c0 1.8-1.5 3.3-3.2 3.3z m10.5-9.8l3.2 3.3v1.6h-27.5v-1.6l3.2-3.3v-8.9c0-4.9 3.5-9.2 8.1-10.3v-1.1c0-1.4 1-2.5 2.5-2.5s2.4 1.1 2.4 2.5v1.1c4.6 1.1 8.1 5.4 8.1 10.3v8.9z' })
        )
    );
};

exports.default = IoAndroidNotifications;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-notifications.js
// module id = 1885
// module chunks = 0